import { render, staticRenderFns } from "./personal-details-step.vue?vue&type=template&id=400c9e72"
import script from "./personal-details-step.vue?vue&type=script&lang=js"
export * from "./personal-details-step.vue?vue&type=script&lang=js"
import style0 from "./personal-details-step.vue?vue&type=style&index=0&id=400c9e72&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports